import config from "../config"
const baseUrl = config.base_url + "agricultural_store_farm/"
export default {
    list: {
        url:  baseUrl + "list",
        type: "get",
    },
    listByAgriculturalStoreId: {
        url:  baseUrl + "listByAgriculturalStoreId",
        type: "get",
    },
    listAll: {
        url:  baseUrl + "listAll",
        type: "get",
    },
    page: {
        url:  baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    save: {
        url:  baseUrl + "save",
        type: "post",
    },
    delete: {
        url:  baseUrl + "delete",
        type: "get",
    },
    deleteByAgriculturalStoreId: {
        url:  baseUrl + "deleteByAgriculturalStoreId",
        type: "get",
    },
    updateGroupId: {
        url:  baseUrl + "updateGroupId",
        type: "get",
    },
    updateUserType: {
        url:  baseUrl + "updateUserType",
        type: "get",
    },
    listSchemesByAgriculturalStoreId: {
        url:  baseUrl + "listSchemesByAgriculturalStoreId",
        type: "get",
    }
}

